/** SignUp API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs, SignUpNs} from '@shared/types'

const api = createApi('signup')

export const SignUpApi = {
  addUserFeatures: (data: SignUpNs.AddUserFeaturesRequest) =>
    api.post<SignUpNs.AddUserFeaturesRequest, CommonNs.GenericResponse>('add-user-features', data),
  addWorkspaces: (data: SignUpNs.AddWorkspaceRequest) =>
    api.post<SignUpNs.AddWorkspaceRequest, SignUpNs.AddWorkspaceResponse>('add-workspace', data),
  inviteMembers: (data: SignUpNs.InviteMembersRequest) =>
    api.post<SignUpNs.InviteMembersRequest, CommonNs.GenericResponse>('invite-members', data),
  register: (data: SignUpNs.RegisterRequest) =>
    api.post<SignUpNs.RegisterRequest, SignUpNs.RegisterResponse>('register', data),
  checkActivationCode: (data: SignUpNs.ActivateAccountRequest) =>
    api.post<SignUpNs.ActivateAccountRequest, SignUpNs.ActivateAccountResponse>('check-activation-code', data),
  activateAccount: (data: SignUpNs.ActivateAccountRequest) =>
    api.post<SignUpNs.ActivateAccountRequest, SignUpNs.ActivateAccountResponse>('activate-account', data),
  confirmPrimaryEmail: (data: SignUpNs.ActivateAccountRequest) =>
    api.post<SignUpNs.ActivateAccountRequest, SignUpNs.ActivateAccountResponse>('confirm-email', data),
  confirmInvitation: (data: SignUpNs.ActivateAccountRequest) =>
    api.post<SignUpNs.ActivateAccountRequest, SignUpNs.ActivateAccountResponse>('confirm-invitation', data),
}
